const isDefined = <T extends object>(value: null | undefined | string | void | T): value is T => {
  if (typeof value === 'string' && value === '') return false;

  return value !== null && value !== undefined;
};

export default isDefined;
